export { default as default } from './DeleteComponent.jsx';